const messages = {
  required: 'validation.required',
  minLength: 'validation.min',
  maxLength: 'validation.max',
  invalid: 'validation.invalid',
  fillField: 'validation.fill-field',
  validEmail: 'login.valid-email',
  pleaseEmail: 'subscription.please-enter-your-email',
  pleaseEnterPassword: 'subscription.please-enter-password',
  passwordLength: 'global.password-length',
  subscriptionRepeatPassword: 'subscription.repeat-password',
  passwordDifferent: 'login.password-different',
  errorEmail: 'global.error-email',
  incorrectPassword: 'global.incorrect-password',
}

export function getMessage(id: string) {
  return messages[id as keyof typeof messages] ?? ''
}
